<template>
  <h1 class="title">игра реакции</h1>
  <p class="regulation"> 
    <strong>правила игры:</strong> <br /><span>
      когда видишь красную кнопку скорее нажми нему и получай свой скорость
      реакции</span>
  </p>
  <button @click="start" :disabled="isPlaying" class="button">играть</button>
  <Block v-if="isPlaying" :delay="delay" @end="endGame" />
  <Result v-if="showResult" :score="score" />
</template>

<script>
import Block from "./components/Block.vue";
import Result from "./components/Result.vue";
export default {
  name: "App",
  components: {
    Block,
    Result,
  },
  data() {
    return {
      delay: 0,
      isPlaying: false,
      score: null,
      showResult: false,
    };
  },
  methods: {
    start() {
      this.delay = 2000 + Math.random() * 5000;
      this.isPlaying = true;
      console.log(this.delay);
      this.showResult = false;
    },
    endGame(result) {
      this.score = result;
      this.isPlaying = false;
      this.showResult = true;
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
body {
  text-align: center;
  background: rgb(54, 255, 178);
}
.regulation{
   font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
   font-size: 24px;
   color: white;
   text-shadow: 1px 1px 2px #000;
}
button {
  color: aliceblue;
  background: rgb(54, 141, 255);
  padding: 5px 30px;
  border-radius: 10px;
  border: 2px solid rgb(33, 89, 161);
}
button:disabled {
  opacity: 0.5;
}
</style>
